import { Component, Input, OnInit } from '@angular/core';
import { CounsellorPublicProfileVM, WhoAmIVM } from '../../../models';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pro-profile-info',
  templateUrl: './pro-profile-info.component.html'
})
export class ProProfileInfoComponent extends BaseComponent implements OnInit{

  @Input() profileModel: CounsellorPublicProfileVM = new CounsellorPublicProfileVM();
  readMore: boolean = false;

  constructor(
    private route: ActivatedRoute,
  ) {
    super(route);
  }

  ngOnInit(): void {
    
  }
}

